
// Helper to get base URL (matches logic in App.js)
const getBaseUrl = () => {
    let baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:8000';
    if (process.env.NODE_ENV === 'production') {
        baseUrl = '/api';
    }
    return baseUrl;
};

const getHeaders = () => {
    const token = localStorage.getItem('token');
    return {
        'Content-Type': 'application/json',
        'Authorization': token ? `Bearer ${token}` : '',
    };
};

const AutomationService = {
    // Workflows
    getWorkflows: async (skip = 0, limit = 100) => {
        const response = await fetch(`${getBaseUrl()}/api/v1/workflows?skip=${skip}&limit=${limit}`, {
            headers: getHeaders(),
        });
        if (!response.ok) throw new Error('Failed to fetch workflows');
        return await response.json();
    },

    createWorkflow: async (data) => {
        const response = await fetch(`${getBaseUrl()}/api/v1/workflows`, {
            method: 'POST',
            headers: getHeaders(),
            body: JSON.stringify(data),
        });
        if (!response.ok) throw new Error('Failed to create workflow');
        return await response.json();
    },

    getWorkflow: async (id) => {
        const response = await fetch(`${getBaseUrl()}/api/v1/workflows/${id}`, {
            headers: getHeaders(),
        });
        if (!response.ok) throw new Error('Failed to fetch workflow');
        return await response.json();
    },

    updateWorkflow: async (id, data) => {
        const response = await fetch(`${getBaseUrl()}/api/v1/workflows/${id}`, {
            method: 'PUT',
            headers: getHeaders(),
            body: JSON.stringify(data),
        });
        if (!response.ok) throw new Error('Failed to update workflow');
        return await response.json();
    },

    // Versions
    saveVersion: async (workflowId, definition) => {
        const response = await fetch(`${getBaseUrl()}/api/v1/workflows/${workflowId}/versions`, {
            method: 'POST',
            headers: getHeaders(),
            body: JSON.stringify({ definition }),
        });
        if (!response.ok) throw new Error('Failed to save version');
        return await response.json();
    },

    publishVersion: async (workflowId, versionId) => {
        const response = await fetch(`${getBaseUrl()}/api/v1/workflows/${workflowId}/publish`, {
            method: 'POST',
            headers: getHeaders(),
            body: JSON.stringify({ version_id: versionId }),
        });
        if (!response.ok) throw new Error('Failed to publish version');
        return await response.json();
    },

    // Execution
    executeWorkflow: async (workflowId, context = {}) => {
        const response = await fetch(`${getBaseUrl()}/api/v1/workflows/${workflowId}/execute`, {
            method: 'POST',
            headers: getHeaders(),
            body: JSON.stringify({ context }),
        });
        if (!response.ok) throw new Error('Failed to execute workflow');
        return await response.json();
    }
};

export default AutomationService;
